import axios from "axios";
import { API_BASE } from "../utils/Constants";
import { getToken, removeUserSession } from "../utils/Auth";
export default (history = null) => {
  const baseURL = API_BASE;

  let headers = {};

  if (getToken()) {
    headers.Authorization = `Bearer ${getToken()}`;
  }

  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers,
  });

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }

      // If the backend explicitly says auth is required, redirect to login
      if (
        error.response.status === 401 &&
        error.response.data &&
        error.response.data.message === "Authentication required"
      ) {
        // Store current path so we can return after successful login
        try {
          const intendedPath =
            window.location.pathname + window.location.search + window.location.hash;
          if (intendedPath && intendedPath !== "/") {
            sessionStorage.setItem("postLoginRedirect", intendedPath);
          }
        } catch (_) {
          // ignore storage errors (private mode, etc.)
        }

        removeUserSession();
        if (history) {
          history.push("/");
        } else {
          window.location = "/";
        }
        return;
      }

      // Don't redirect to login if we're on a tokenized callDashboard URL
      const isTokenizedCallDashboard = window.location.pathname.startsWith('/callDashboard/') && 
                                       window.location.pathname.split('/').length === 3;
      
      if (error.response.status === 401 && !error.response.data.message) {
        if (!isTokenizedCallDashboard) {
          removeUserSession();
          if (history) {
            history.push("/");
          } else {
            window.location = "/";
          }
        } else {
          return new Promise((resolve, reject) => {
            reject(error);
          });
        }
      } else {
        if (
          error.response.status === 401 &&
          error.response.data.code === "E_JWT_TOKEN_EXPIRED"
        ) {
          if (!isTokenizedCallDashboard) {
            removeUserSession();
            if (history) {
              history.push("/");
            } else {
              window.location = "/";
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(error);
            });
          }
        } else {
          return new Promise((resolve, reject) => {
            reject(error);
          });
        }
      }
    }
  );

  return axiosInstance;
};

